import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import { useTransactionData } from "@/context/transactionContext";
import { getTransactionData } from "@/services/api";
import CircularLoader from "@/components/atoms/CircularLoader";
import WithdrawalStatus from "./WithdrawalStatus";
import WithdrawalStatus1xbet from "./WithdrawalStatus1xbet";

function WithdrawalStatusIndex() {
  const { id, token } = useParams();
  const { transactionData, setTransactionData } = useTransactionData();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasData = !!transactionData?.id;
  const canFetch = !!id && !!token;
  const needsHydration = !hasData && canFetch;

  useEffect(() => {
    const hydrateWithdrawal = async () => {
      if (needsHydration && !isLoading) {
        try {
          setIsLoading(true);
          const res = await getTransactionData(id, token);
          setTransactionData(res.data);
        } catch (err) {
          setError("No se pudo validar el estado del retiro.");
        } finally {
          setIsLoading(false);
        }
      }
    };

    hydrateWithdrawal();
  }, [needsHydration, id, token, setTransactionData, isLoading]);

  if (isLoading || (needsHydration && !error)) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-white sm:bg-gray-900">
        <CircularLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-red-500">
        {error}
      </div>
    );
  }

  return <FinalWithdrawalView />;
}

function FinalWithdrawalView() {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <WithdrawalStatus1xbet /> : <WithdrawalStatus />;
}

export default WithdrawalStatusIndex;
